
import React from 'react';
import { Brain, HeartHandshake, Shield, Target } from 'lucide-react';

const DecisionPathSection = () => {
  return (
    <section className="py-12 md:py-16 bg-joerg-50">
      <div className="container px-4 sm:px-6 md:px-8">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-center mb-8 text-joerg-800">Dein Weg zur richtigen Entscheidung</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm border border-joerg-100">
              <div className="flex items-center justify-center mb-3">
                <div className="bg-[#2F855A]/10 rounded-full p-2">
                  <Brain className="h-5 w-5 text-[#2F855A]" />
                </div>
              </div>
              <h3 className="text-xl font-medium text-joerg-800 text-center mb-3">Individuelle Bedarfsanalyse</h3>
              <p className="text-joerg-600 text-left">
                Im kostenfreien Erstgespräch <span className="text-joerg-700 font-medium">erkunden wir gemeinsam deine Situation</span> und erarbeiten ein klares Bild deiner Ziele und Bedürfnisse.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-joerg-100">
              <div className="flex items-center justify-center mb-3">
                <div className="bg-[#2F855A]/10 rounded-full p-2">
                  <HeartHandshake className="h-5 w-5 text-[#2F855A]" />
                </div>
              </div>
              <h3 className="text-xl font-medium text-joerg-800 text-center mb-3">Transparente Beratung</h3>
              <p className="text-joerg-600 text-left">
                Du erhältst eine <span className="text-joerg-700 font-medium">ehrliche Einschätzung</span>, ob ein bestehendes Paket passt oder ob eine maßgeschneiderte Lösung sinnvoller wäre.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-joerg-100">
              <div className="flex items-center justify-center mb-3">
                <div className="bg-[#2F855A]/10 rounded-full p-2">
                  <Shield className="h-5 w-5 text-[#2F855A]" />
                </div>
              </div>
              <h3 className="text-xl font-medium text-joerg-800 text-center mb-3">Ohne Verkaufsdruck</h3>
              <p className="text-joerg-600 text-left">
                Kein überredender Verkauf, sondern eine <span className="text-joerg-700 font-medium">partnerschaftliche Entscheidungsfindung</span> basierend auf deinen tatsächlichen Bedürfnissen.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm border border-joerg-100">
              <div className="flex items-center justify-center mb-3">
                <div className="bg-[#2F855A]/10 rounded-full p-2">
                  <Target className="h-5 w-5 text-[#2F855A]" />
                </div>
              </div>
              <h3 className="text-xl font-medium text-joerg-800 text-center mb-3">Ergebnisorientierte Lösung</h3>
              <p className="text-joerg-600 text-left">
                Das Ziel ist, <span className="text-joerg-700 font-medium">die optimale Begleitung für dich zu finden</span> – unabhängig davon, ob es ein Standardpaket oder ein individuell angepasstes Format ist.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DecisionPathSection;
